import { alpha, useTheme } from '@mui/material';
const useAccountInformationStyles = () => {
    const theme = useTheme();
    const headerHeight = '48px';
    const bottomNavigationHeight = '56px';
    return {
        accountInformationSectionStyles: {
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            height: `calc(100dvh - ${headerHeight} - ${bottomNavigationHeight})`,
            overflowY: 'auto',
            position: 'relative',
            ".account-info-form": {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                padding: '8px 0',
                gap: '24px',
            }
        },
        accountInformationButtonStyles: {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            mt: 'auto',
            mb: 1
        },
        textFieldStyles: {
            '& fieldset': {
                borderStyle: 'dashed',
            }
        }
    };
};
export default useAccountInformationStyles;
